export default __webpack_public_path__ + "static/media/equivia.b7942b81.svg";